module.exports = __webpack_public_path__ + "fa04607326f793e8b6e8cfe789ecfec3.svg";